<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Assign Learner Quota </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                    <v-radio label="Assign Quota For Single Student" value="single" color="#0f2027"></v-radio>
                    <v-radio label="Assign Quota For Bulk Student" value="bulk" color="#0f2027"></v-radio>
                </v-radio-group>
            </v-row>
            <span v-if="radios=='single'">
                <v-row dense justify="center">
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete
                            v-model="registration_no"
                            @change="getReport()"
                            :loading="comp_load"
                            rounded
                            :items="stud_list"
                            label="Select Student"
                            item-value="lid"
                            item-text="name"
                            outlined
                            dense
                            prepend-icon="mdi-account-child-circle"
                        ></v-autocomplete>
                    </v-col>
                    <!-- <v-btn class="button mt-4" v-if="registration_no != null" @click="getReport()">Proceed</v-btn> -->
                </v-row>
                <v-col cols="12" sm="12" md="12" v-if="registration_no">
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Assigned Learner Quota </v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn small class="mb-2 button" @click="dialog = true">Assign new Quota</v-btn>
                    </v-toolbar>
                    <br />
                    <v-data-table
                        v-if="learner_quota_history_list!=''"
                        :items="learner_quota_history_list"
                        :headers="headers"
                        class="elevation-1 mytable"
                        dense
                    >
                        <template v-slot:item.action="{ item }">
                            <div>
                                <v-avatar style="" size="25" class="edit-avatar">
                                    <v-icon class="edit-v-icon mr-2" @click="editItem(item)"> edit </v-icon>
                                </v-avatar>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title class="toolbar">
                            <span class="headline">Assign / Edit Quota</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                        <v-autocomplete
                                            rounded
                                            outlined
                                            dense
                                            :items="ay_lists"
                                            item-value="id"
                                            item-text="ay"
                                            v-model="addedItem.academicyear"
                                            label="Select Academic Year"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                        <v-text-field
                                            rounded
                                            outlined
                                            dense
                                            v-model="editedItem.academicyear"
                                            persistent-hint
                                            :disabled="editedIndex != -1"
                                            label="Academic Year"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                        <v-autocomplete
                                            rounded
                                            outlined
                                            dense
                                            :items="quota_list"
                                            item-value="name"
                                            item-text="name"
                                            v-model="addedItem.quota"
                                            label="Select Quota"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                        <v-autocomplete
                                            rounded
                                            outlined
                                            dense
                                            :items="quota_list"
                                            item-text="name"
                                            v-model="editedItem.quota"
                                            label="Select Quota"
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="button" @click="dialog = false">Cancel</v-btn>
                            <v-btn class="button" @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </span>
            <span v-else>
                <v-row center dense justify="center">
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete
                            rounded
                            outlined
                            dense
                            v-model="ay"
                            :items="ay_list"
                            item-value="ay_id"
                            item-text="academicyear"
                            persistent-hint
                            label="Academic Year"
                            :loading="comp_load"
                        ></v-autocomplete>
                    </v-col>
                    <!-- <v-col cols="12" sm="3" md="3">
                        <v-autocomplete
                            rounded
                            outlined
                            dense
                            :items="quota_list"
                            item-value="name"
                            item-text="name"
                            v-model="quota"
                            label="Select Quota"
                            :loading="comp_load"
                        ></v-autocomplete>
                    </v-col> -->
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete
                            rounded
                            outlined
                            dense
                            :items="standard_list"
                            item-value="id"
                            item-text="standard"
                            v-model="standard"
                            label="Select Standard"
                            :loading="comp_load"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="ay" class="pt-0 pt-none">
                        <v-btn class="button" @click="fetchLearnerData()">Fetch</v-btn>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="this.selected!=''">
                    <strong>Total Selected - {{ selected.length }}</strong>
                </v-row>
                <v-row justify="center" v-if="this.selected!=''">
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete
                            rounded
                            outlined
                            dense
                            :items="quota_list"
                            item-value="name"
                            item-text="name"
                            v-model="quota"
                            label="Select Quota"
                            :loading="comp_load"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="quota && ay" class="pt-0 pt-none">
                        <v-btn class="button" v-bind="attrs" v-on="on" @click="assignQuota()">Assign Quota</v-btn>
                    </v-col>
                </v-row>
                <center v-if="quota && ay">
                    <strong>
                        Note : If you click on Assign Quota, the selected quota will be assigned. If a quota has already
                        been assigned, the old quota will be removed and the selected quota will be assigned.
                    </strong>
                </center>

                <v-data-table
                    v-if="learner_list!=''"
                    :headers="headersquota"
                    @current-items="getFiltered"
                    :items-per-page="-1"
                    :items="bookList1"
                    dense
                    sort-by=""
                    class="elevation-1 mytable"
                    :search="search"
                    show-select
                    v-model="selected"
                    item-key="id"
                >
                    <template v-slot:top class="pb-5">
                        <v-row justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headersquota" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete
                                                        class="mr-2 pb-5 pt-2"
                                                        flat
                                                        hide-details
                                                        small
                                                        rounded
                                                        dense
                                                        outlined
                                                        color="#0F2027"
                                                        :label="header.text"
                                                        multiple
                                                        clearable
                                                        :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"
                                                    ></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                </v-data-table>
            </span>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                comp_load: false,
                fetch_loader: false,
                com_sub_loader: false,
                overlay: false,
                selected: [],
                stud_list: [],
                snackbar: false,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                registration_no: null,
                learner_info: null,
                learner_quota_history_list: [],
                ay_list: [],
                ay_lists: [],
                quota_list: [],
                dialog: false,
                radios: null,
                quota: null,
                standard_list: [],
                standard: null,
                ay: null,
                learner_list: [],
                total_stud: [],
                headers: [
                    { text: "Academic Year", value: "academicyear", sortable: true },
                    { text: "Quota", value: "quota", sortable: true },
                    { text: "Actions", value: "action", sortable: false },
                ],
                filterArr: [],
                filters: {
                    standard: [],
                    registration_number: [],
                    name: [],
                },
                headersquota: [
                    { text: "Roll No.", value: "roll_no", sortable: true },
                    { text: "Registration Number", value: "registration_number", sortable: true },
                    { text: "Name", value: "name", sortable: true },
                    { text: "Standard", value: "standard", sortable: true },
                    { text: "Quota", value: "quota", sortable: true },
                ],
                editedIndex: -1,
                editedItem: {
                    academicyear: null,
                    quota: null,
                },
                addedItem: {
                    academicyear: null,
                    quota: null,
                },
                defaultItem: {
                    academicyear: null,
                    quota: null,
                },
            };
        },
        computed: {
            bookList1() {
                return this.learner_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.learner_list.map((d) => d[val]);
            },
            editItem(item) {
                this.editedIndex = this.learner_quota_history_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            async fetchLearnerData() {
                this.learner_list = [];
                this.overlay = true;
                const data = {
                    ay: this.ay,
                    standard: this.standard,
                };
                try {
                    const res = await axios.post("/AccountingAndFees/fetchLearnerData", data);
                    if (res.data.flag == "YES") {
                        this.learner_list = res.data.learner_list;
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false;
                    }
                    this.overlay = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                }
            },
            async assignQuota() {
                if (!confirm("Are you sure you want to assign quota ?")) return;
                this.overlay = true;
                for (var i = 0; i < this.selected.length; i++) {
                    this.total_stud.push(this.selected[i].id);
                }
                const data = {
                    ay: this.ay,
                    quota: this.quota,
                    selected: this.total_stud,
                };
                try {
                    const res = await axios.post("/AccountingAndFees/saveAllLearnerQuotaHistory", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Saved Successfully");
                        this.fetchLearnerData();
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false;
                    }
                    this.overlay = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                    this.selected = [];
                    this.quota = null;
                    this.total_offer = [];
                }
            },
            async save() {
                var ay;
                var lquota;
                if (this.editedIndex > -1) {
                    ay = this.editedItem.ay_id;
                    lquota = this.editedItem.quota;
                } else {
                    ay = this.addedItem.academicyear;
                    lquota = this.addedItem.quota;
                }
                const data = {
                    lid: this.registration_no,
                    ay: ay,
                    quota: lquota,
                };
                try {
                    const res = await axios.post("/AccountingAndFees/saveEditLearnerQuotaHistory", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Saved Successfully");
                        this.dialog = false;
                        this.getReport();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false;
                    }
                    this.overlay = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                this.comp_load = true;
                axios
                    .post("/admission/getAllStudents_for_account")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.stud_list = res.data.stud_list;
                            this.ay_list = res.data.academic_year_list;
                            this.standard_list = res.data.standard_list;
                            this.quota_list = res.data.quota_list;
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            async getReport() {
                this.overlay = true;
                const data = {
                    lid: this.registration_no,
                };
                try {
                    const res = await axios.post("/AccountingAndFees/getLearnerQuotaHistory", data);
                    if (res.data.flag == "YES") {
                        this.learner_quota_history_list = res.data.learner_quota_history_list;
                        this.ay_lists = res.data.ay_list;
                        this.quota_list = res.data.quota_list;
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false;
                    }
                    this.overlay = false;
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                }
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
